import { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { Downgraded } from "@hookstate/core";
import "./index.scss";
import {
  setCategoryCallSheet,
  setCommentCallSheet,
  setUnSavedCallSheet,
  setTimeCallSheet,
  useCallSheetState,
  setParticipantsCallSheet,
} from "../../../../hooks/callSheet";
import TimeTool from "../../time-tool";
import CustomModal from "../../warning-modal";
import { formatTime } from "../../../../helper/converters";

const ProjectCard = (props: any) => {
  const { projectCard, numProject, time, category, comment } = props;
  const defaultImage =
    "https://cinemahive.s3.amazonaws.com/images/logos/Project+%E2%80%93+1.png";
  const placeholder = "Notes: ";

  const callSheetState = useCallSheetState();
  const unsavedFlag = callSheetState.unsaved.get();
  callSheetState.attach(Downgraded);

  const { client_logo_url: urlAvatar, project_name: title } =
    projectCard.getProject;

  const [openTimeModal, setOpenTimeModal] = useState(false);
  const [commentTxt, setCommentTxt] = useState("");
  const [categoryTxt, setCategoryTxt] = useState("");
  const [enableFlag, setEnableFlag] = useState(true);

  const handleAutocomplete = (event: any, nextValue: string) => {
    if (!unsavedFlag) setUnSavedCallSheet(true);
    setCategoryCallSheet(nextValue);
    setCategoryTxt(nextValue);
  };

  const handleDescription = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (!unsavedFlag) setUnSavedCallSheet(true);
    setCommentCallSheet(event.target.value);
    setCommentTxt(event.target.value);
  };

  const updateTime = (time: { hour: string; mins: string; amPm: string }) => {
    const timeStr = `${time.hour.length > 1 ? time.hour : "0" + time.hour}:${time.mins.length > 1 ? time.mins : "0" + time.mins
      } ${time.amPm}`;
    setTimeCallSheet(timeStr);
    const tempParticipants: any[] = callSheetState.participant
      .get()
      .map((n) => ({
        email: n.email,
        id: n.id,
        time: timeStr,
      }));
    setParticipantsCallSheet(tempParticipants);
    if (!unsavedFlag) setUnSavedCallSheet(true);
  };

  const onClickInput = () => {
    if (enableFlag) {
      const time = callSheetState.time.get();
      const modifyItem = callSheetState.participant
        .get()
        .find((item) => item.time !== time);
      if (modifyItem) setOpenTimeModal(true);
    }
  };

  const handleCloseTimeModal = () => setOpenTimeModal(false);
  const handleContinueTimeModal = () => {
    setOpenTimeModal(false);
    setEnableFlag(false);
    setTimeout(() => {
      setEnableFlag(true);
    }, 7000);
  };

  useEffect(() => {
    setUnSavedCallSheet(false);
  }, []);

  useEffect(() => {
    setCommentTxt(comment);
    setCategoryTxt(category);
    setCommentCallSheet(comment);
    setCategoryCallSheet(category);
  }, [category, comment]);

  return (
    <div className="card">
      <div className="card-image">
        <img
          className="square"
          src={urlAvatar ? urlAvatar : defaultImage}
          alt="user"
        />
      </div>
      <div className="card-information">
        <h4 className="card-information-title">{title}</h4>
        {numProject && (
          <h4 className="card-information-sub-title">
            {`Project Number: ${numProject}`}
          </h4>
        )}
        <h4 className="card-information-sub-title">General Crew Call:</h4>
        <TimeTool
          size="big"
          updateTime={(e: any) => updateTime(e)}
          onClickInput={onClickInput}
          time={time ? formatTime(time) : ""}
        />
      </div>
      <hr className="divide-line" />
      <Autocomplete
        sx={{ fontSize: "10px" }}
        fullWidth
        id="category"
        disableClearable
        options={["SHOOT DAY", "SCOUT", "REHEARSAL", "MEETING", "FITTING"]}
        onChange={handleAutocomplete}
        value={categoryTxt}
        renderOption={(props, option) => (
          <Box
            component="li"
            {...props}
            key={option}
          >
            {option}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            name="category"
            label="Category"
            value={categoryTxt}
          />
        )}
      />
      <div className="card-information-textarea">
        <textarea
          rows={5}
          maxLength={200}
          value={commentTxt}
          placeholder={placeholder}
          onChange={handleDescription}
        ></textarea>
      </div>
      <CustomModal
        message="This action will automatically change the call time of the entire crew. Would you like to continue? "
        open={openTimeModal}
        leftButton="Cancel"
        rightButton="Continue"
        onClose={handleCloseTimeModal}
        onContinue={handleContinueTimeModal}
      />
    </div>
  );
};

export default ProjectCard;
